/* eslint-disable @typescript-eslint/ban-types */
import { Cell } from 'react-table';

import { formatNumberCompact } from '@trqk/utils';

interface Props<D extends object> {
    cell: Cell<D>;
}

/**
 * Similar to CompactNumberCell. Formats a number into a compact string, except when the number is
 * 0; in that case, it returns an emdash. For example, given the input `1000`, the output would be
 * '1K'; given the input '0', the output would be '-'.
 * @param param
 */
export function PlaysCell<D extends object>({ cell }: Props<D>): string {
    const { value } = cell;

    if (value === 0 || value === null) {
        return '—';
    }

    return formatNumberCompact(value);
}
